import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { type ExportFormat, KEYS } from '~shared/api/query-keys';

export interface OutstandingAndOverdueRow {
  parentName: string;
  studentName: string;
  amountDue: number;
  dueDate: string | null;
  daysOverdue: number;
  status: string;
}

export interface GetOutstandingAndOverdueResponse {
  studioName: string;
  rows: Array<OutstandingAndOverdueRow>;
}

export const reportingOutstandingAndOverdueAPI = async (params: {
  format: ExportFormat;
}) => {
  const response = await baseAPI.get<
    GetOutstandingAndOverdueResponse | string | null
  >('/reporting/outstanding-and-overdue', {
    params,
    responseType: params.format === KEYS.EXPORT_FORMAT.CSV ? 'text' : 'json',
  });

  return response.data;
};

export const useReportingOutstandingAndOverdue = (params: {
  format: ExportFormat;
}) => {
  return useQuery({
    queryKey: [KEYS.OUTSTANDING_AND_OVERDUE, params.format],
    queryFn: () => reportingOutstandingAndOverdueAPI(params),
    enabled: !!params.format, // only fetch if format is provided (for CSV)
  });
};
